export default __webpack_public_path__ + "static/media/kursi-putih.6134b0a8.png";